import React, {useEffect, useRef, useState} from "react";
// React Bootstrap
import {Form, ListGroup} from "react-bootstrap";
// Styled components
import styled from "styled-components";
// Observer
import useObserver from "../hooks/UseObserver";
// Custom hooks
import {useIsMount} from "../hooks/UseIsMount";
// Custom spinner
import CustomSpinner from "./CustomSpinner";
import { typeImplementation } from "@testing-library/user-event/dist/type/typeImplementation";

const TableContainer = styled.div`
  max-height: 200px;
  overflow-x: auto;
  overflow-y: visible;
  position: absolute;
  z-index: 999;
  width: 100%;
  border: 1px solid grey;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => "#e3dae17a"};
`;
// REQUESTS CON OBSERVER
// Componente con un buscador y un select para buscar entre las opciones del select
// defaultValue       => Value por defecto que tendrá el select (TIENE QUE TENER UN NAME TAMBIÉN)
// options            => Options del select
// name               => Nombre del input a enviar
// reactHookFormsRef  => Validaciones
// isInvalid          => Is invalid del react hook form
// requestMoreOptions => Petición para pedir mas opciones
// setOptionParent    => En caso de necesitar setear el estado en el padre se ejecutará esta función.
// ErrorMessage       => Componente para que se muestre el mensaje de error

const SearchSelectObserver = ({ options, requestMoreOptions, defaultValue, name, reactHookFormsRef, methods, setOptionParent, reset, ErrorMessage }) => {
  // Name del search
  const [searchValue, setSearchValue] = useState("");

  // Value del name
  const [optionValue, setOptionValue] = useState("");

  // Page del observador
  const [page, setPage] = useState(0);

  // Para saber si ha alcanzado la ultima página
  const [lastPageReached, setLastPageReached] = useState(false);

  // Spinner
  const [loading, setLoading] = useState(false);

  // Para saber si el input esta siendo focuseado y mostrar la lista con las opciones
  const [focused, setFocused] = useState(false);

  // Para que no se cargue en el primer renderizado
  const isMount = useIsMount();

  // Scroll Div para el observador
  const scrollingDiv = useRef(null);

  // Referencia al div del search select
  const divRef = useRef(null);

  // Para establecer el valor por defecto
  useEffect(() => {
    if (!searchValue && defaultValue?.name && !optionValue && defaultValue?.value) {
      setSearchValue(defaultValue.name);
      setOptionValue(defaultValue.value);
      methods?.setValue(name, defaultValue.value);
    }
  }, [defaultValue?.name]);

  // Para resetear el search observer
  useEffect(() => {
    !isMount && resetSearchSelectObserver();
  }, [reset]);

  // Use Effect controla que se clicke fuera del div
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setFocused(false);
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    // Reseteamos el componente si se clicka fuera también
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [divRef]);

  // UEF para controlar cuando se desfocusea que se limpie el valor de la búsqeuda o cuando se focusea se resetee
  useEffect(() => {
    // Opcion actual del search select
    let actualOption = options?.find((element) => element.value === optionValue);
    // Si se focusead eliminamos search value
    if (focused) {
      resetSearchSelectObserver();
    }
    // Si cerramos y no tenemos marcado ninguna opcion
    if (!actualOption && !focused) {
      resetSearchSelectObserver();
    }
  }, [focused]);

  // Cuando se haga una búsqueda volvemos a pedir desde el principio
  const searchAction = async (mySearchValue) => {
    setLoading(true);
    let response = await requestMoreOptions(1, encodeURIComponent(mySearchValue.trim()));
    setLoading(false);
    if (response.totalPages <= 1) {
      setLastPageReached(true);
    } else {
      setLastPageReached(false);
    }
    setOptionValue("");
    methods?.setValue(name, "");
    setPage(1);
  };

  // Función para asignar un value y un name a los inputs cuando se selecciona un valor de la lista
  // option => Valores a asignar
  const setSearchAndOptionValues = (option) => {
    setSearchValue(option.name);
    setOptionValue(option.value);
    if (setOptionParent) setOptionParent(option.value);
  };

  // Devuelve una lista de botones que hacen referencia a las opciones del select
  // options  => Opciones a tener en cuenta
  const getListOptions = (options) => {
    if (options?.length) {
      return options.map((option) => {
        return (
          <ListGroup.Item
            action
            key={options.value}
            onClick={(e) => {
              setSearchAndOptionValues(option);
              setFocused(false);
              methods?.setValue(name, option.value);
              methods?.clearErrors(name);
              e.preventDefault();
            }}
          >
            {option.component ? option.component : option.name}
          </ListGroup.Item>
        );
      });
    } else return <ListGroup.Item>{"No hay opciones disponibles"}</ListGroup.Item>;
  };

  // Función que resetea el componente
  const resetSearchSelectObserver = () => {
    setPage(0);
    setLastPageReached(false);
    setSearchValue("");
    setOptionValue("");
    methods?.setValue(name, "");
  };

  const loadMore = async () => {
    // Si el searchValue es === a el defaultValue.name no se tiene en cuenta a la hora de cargar más
    let mySearchValue = searchValue === defaultValue?.name ? "" : searchValue;

    // Cargamos mas elementos
    if (!lastPageReached) {
      setPage(page + 1);
      setLoading(true);
      let response = await requestMoreOptions(page + 1, mySearchValue, page !== 0);
      if (response?.totalPages <= page + 1) {
        setLastPageReached(true);
      } else {
        setLastPageReached(false);
      }
      setLoading(false);
    }
  };

  // Observador
  const target = useRef(null);

  useObserver(
    loadMore,
    {
      root: scrollingDiv.current,
      rootMargin: "0px",
      threshold: 1,
    },
    target,
    options
  );

  return (
    <div ref={divRef} className="position-relative flex-grow-1">
      <CustomSpinner loading={loading} animation={"border"} />
      {/*Input que tendrá el value de la opción seleccionada  NO SE VE*/}
      <Form.Control className={"d-none"} name={name} {...reactHookFormsRef} type="text" value={optionValue} />
      {/*Input que tendrá el nombre de la opción seleccionada */}
      <Form.Control
        name="mySearchSelectName"
        type="text"
        placeholder="Busque y seleccione"
        onFocus={() => {
          setFocused(true);
        }}
        value={searchValue}
        onChange={(searchContent) => {
          setSearchValue(searchContent.target.value);
          searchAction(searchContent.target.value);
        }}
        isInvalid={methods?.formState?.errors[name]}
        autocomplete="off"
      />

      {ErrorMessage && <ErrorMessage errors={methods?.formState?.errors} name={name} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />}

      {/*Lista con botones que mostrará las opciones del select */}
      <TableContainer className={focused ? "" : "d-none"} ref={scrollingDiv}>
        <ListGroup>{getListOptions(options)}</ListGroup>
        <div ref={target} id="observableHelper" />
      </TableContainer>
    </div>
  );
};

export default SearchSelectObserver;
